// @flow
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import * as qs from 'query-string';

import { extractClientAndProviderInfo } from 'common/utils/URLUtils';

const useClientIdFromQuery = (): { clientId: ?string, providerId: ?string } => {
    const { search } = useLocation();
    const clientInfo = React.useMemo(() => {
        const { clientId } = qs.parse(search);
        return clientId ? extractClientAndProviderInfo(clientId) : null;
    }, [search]);

    return {
        clientId: clientInfo?.clientId,
        providerId: clientInfo?.providerId
    };
};

export default useClientIdFromQuery;
